import { defineMessages } from 'react-intl'

export default defineMessages({
  hold: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.HoldOrder.hold',
    defaultMessage: 'Hold order',
  },
  resume: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.HoldOrder.resume',
    defaultMessage: 'Resume order',
  }
})
